import util from './shared/util.js';
import config from '../config.js';

const servicesURL = `${config.server.url}:${config.server.webServicesPort}/contract/`;

class cdoContract {
    create = (data, callback) => {
        util.putJSON(servicesURL + 'create', data, callback);
    }

    update = (data, callback) => {
        util.putJSON(servicesURL + 'update', data, callback);
    }

    selectAll = (callback) => {
        util.getJSON(`${servicesURL}select-all`, callback);
    }

    selectByEntity = (idEntity, callback) => {
        util.getJSON(`${servicesURL}select-by-entity?idEntity=${encodeURIComponent(idEntity ?? '')}`, callback);
    }

    select = (data, callback) => {
        util.putJSON(servicesURL + 'select', data, callback);
    }

    delete = (data, callback) => {
        util.putJSON(servicesURL + 'delete', data, callback);
    }
}

const cdo = new cdoContract();
export default cdo;
